import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { type AerosTagData, AerosTagStack } from "@/components/UiKit"

interface ProductSelectionChipsProps {
  chips: AerosTagData[]
  onRemove: (tag: AerosTagData) => void
}

export const ProductSelectionChips: FC<ProductSelectionChipsProps> = ({ chips, onRemove }) => {
  if (!chips.length) return null

  return (
    <Box className='flex items-center gap-2' data-testid='customer-orders.product-selection-dialog.chips'>
      <Typography variant='body2' className='shrink-0 text-gray-700'>
        Selected products:
      </Typography>
      <AerosTagStack tags={chips} onDelete={onRemove} shouldWrap />
    </Box>
  )
}
